var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepsolLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 48,
    viewBox: "0 0 190 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1038 26.2526C13.1755 25.5158 13.2831 24.779 13.4384 24.018V23.9939C13.4145 23.9939 13.3906 23.9939 13.3787 24.006C12.279 24.1147 10.5458 24.2476 9.25492 24.4167C7.00779 24.7186 4.96382 25.0206 4.79648 25.226C4.33031 25.7816 7.41416 26.1922 12.0996 26.2527L13.1038 26.2526Z",
    fill: "url(#paint0_linear_20163_45278)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7113 4.60751C29.3122 4.60751 22.0091 8.83506 17.5028 15.0317C17.5028 15.0317 7.00811 15.7926 6.45806 16.7348C4.80857 19.9356 4.76074 25.3104 4.76074 25.3104V25.2983C4.77269 25.2742 4.78465 25.25 4.7966 25.2259C4.96394 25.0205 7.00792 24.7186 9.25504 24.4166C10.534 24.2475 12.2791 24.1146 13.3788 24.0059C13.4027 24.0059 13.4147 24.0059 13.4386 23.9938C17.0842 23.6314 24.041 23.1241 28.0092 23.0154C37.751 22.7497 46.1537 22.8222 51.9867 23.0879C53.684 12.7967 47.0144 4.60742 36.7107 4.60742L36.7113 4.60751Z",
    fill: "url(#paint1_linear_20163_45278)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9984 23.088C46.1773 22.8223 37.7745 22.7377 28.0209 23.0155C24.0406 23.1242 17.084 23.6316 13.4384 23.9939C13.3667 24.4046 13.2352 25.081 13.1276 25.9628V26.0111C13.0917 26.3131 13.0678 26.615 13.0439 26.917V26.9774C13.032 27.2673 13.02 27.5572 13.02 27.8471C13.02 28.0282 13.02 28.2094 13.032 28.3906C13.032 28.5476 13.032 28.6926 13.0439 28.8375C13.0559 29.1516 13.0798 29.4777 13.1037 29.7918C13.1156 29.8763 13.1276 29.9729 13.1395 30.0575C13.1635 30.2991 13.1993 30.5407 13.2352 30.7822C13.2471 30.8788 13.271 30.9755 13.283 31.0721C13.3188 31.3016 13.3667 31.5311 13.4145 31.7606C13.4384 31.8572 13.4503 31.9418 13.4742 32.0263C13.534 32.2558 13.5938 32.4974 13.6535 32.7269C13.6655 32.7631 13.6774 32.7994 13.6894 32.8477C17.3589 32.4853 21.8651 32.135 27.1841 31.9176C27.2439 31.9176 29.515 31.8331 29.5388 31.8331C34.4636 31.6761 45.5558 31.7606 48.5559 31.7968C49.0341 31.7968 49.3329 31.8089 49.3329 31.8089C51.855 31.8452 52.8829 31.8693 55.5008 32.0143C56.708 32.0747 58.7161 32.1592 58.8237 32.4249V32.437C58.8237 32.4491 58.8237 32.4491 58.8117 32.4612C60.4732 29.3569 60.4971 24.2234 60.4971 24.2234C60.5927 23.7765 57.4252 23.3416 51.9984 23.088Z",
    fill: "url(#paint2_linear_20163_45278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1766 14.5123H51.3759C49.332 8.59392 43.9051 4.59552 36.7217 4.59552C29.3226 4.59552 22.0195 8.83517 17.5132 15.0197C20.7524 14.7177 24.984 14.464 29.1312 14.3916C29.944 14.3795 31.4979 14.0413 32.3705 12.7368C33.9961 10.2969 35.5978 7.83264 37.8686 7.01136C37.9045 6.99926 37.9523 6.97512 37.9881 6.96305C41.4545 5.64646 46.0207 8.89546 49.1766 14.5123Z",
    fill: "url(#paint3_linear_20163_45278)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5546 31.8091C45.5544 31.785 34.4741 31.6883 29.5375 31.8454C29.5135 31.8454 27.2545 31.9299 27.1827 31.9299C21.8637 32.1473 17.3574 32.4855 13.688 32.86C15.5526 39.1168 21.1108 43.4046 28.5455 43.4046C36.3987 43.4046 44.1559 38.6335 48.5549 31.8088L48.5546 31.8091Z",
    fill: "#E4002B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5545 31.8091C44.1439 38.6337 36.3983 43.4049 28.5452 43.4049C25.0071 43.4049 21.8994 42.4387 19.4009 40.7476C16.6518 38.8875 14.6556 36.1456 13.6753 32.8603C17.3449 32.4979 21.851 32.1476 27.17 31.9302C27.2418 31.9302 29.5128 31.8457 29.5248 31.8457C34.4733 31.6886 45.5655 31.7732 48.5537 31.8094L48.5545 31.8091Z",
    fill: "url(#paint4_linear_20163_45278)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5546 31.8091C47.8135 31.797 46.5704 31.797 45.0404 31.785C41.5024 31.7608 36.3508 31.7487 32.6809 31.785C31.8681 32.4493 30.9478 33.4398 30.5175 34.3336C27.6607 39.2133 26.6686 43.9965 17.8354 36.701C17.8354 36.701 16.425 36.5682 15.4688 36.7494C16.4369 38.2471 17.6801 39.5275 19.1383 40.5662C19.2459 40.6387 19.3415 40.6991 19.4132 40.7474C19.5806 40.8561 19.736 40.9648 19.9033 41.0735C22.3058 42.5592 25.2342 43.4048 28.5454 43.4048C36.3986 43.4048 44.1556 38.6339 48.5546 31.8091Z",
    fill: "url(#paint5_linear_20163_45278)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8335 32.425C58.7259 32.1592 56.7178 32.0867 55.5106 32.0143C52.8809 31.8693 51.853 31.8452 49.3427 31.8089C49.3427 31.8089 49.0439 31.8089 48.5657 31.7968C48.1235 32.4733 47.6573 33.1255 47.1553 33.7657C54.0879 33.5604 58.6425 33.0651 58.8335 32.425Z",
    fill: "url(#paint6_linear_20163_45278)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.15 28.0402C148.254 23.1485 152.7 17.725 158.294 16.1669C164.808 14.8382 170.295 17.3747 171.287 22.4237C171.98 27.3638 168.215 32.5334 161.904 34.0195C155.939 35.1429 150.19 32.9803 149.15 28.0402ZM157.541 22.0973C155.354 24.6096 154.792 27.8952 156.286 29.4168C157.78 30.9387 160.756 30.1415 162.932 27.6291C165.107 25.1168 165.681 21.8312 164.187 20.3096C162.704 18.7877 159.728 19.5849 157.541 22.0973ZM127.228 21.143C127.193 20.4787 126.87 19.9835 126.284 19.6694C125.698 19.3554 124.838 19.1863 123.726 19.1863H122.591L121.515 24.2954H122.423C124.001 24.2954 125.208 24.0297 126.057 23.4861C126.894 22.9305 127.288 22.1577 127.228 21.143ZM114.809 33.5842C114.809 33.5842 113.112 33.6566 113.339 32.026L116.304 17.9903C116.471 17.181 117.26 16.5287 118.061 16.5287H125.22C126.535 16.5287 127.683 16.6133 128.663 16.7703C129.655 16.9153 130.515 17.1689 131.245 17.5313C131.974 17.8936 132.535 18.3647 132.942 18.9566C133.348 19.5364 133.575 20.406 133.635 21.2757C133.755 23.2445 132.87 24.8389 130.97 26.0347C129.069 27.2426 126.344 27.7016 122.782 27.7016H120.81L119.555 33.584L114.809 33.5842ZM87.1265 21.0826C87.0787 20.394 86.7918 19.9109 86.2539 19.6331C85.716 19.3432 84.951 19.1983 83.9351 19.1983H82.3214L81.3532 23.7882H82.9549C84.3414 23.7882 85.3933 23.5587 86.1224 23.0756C86.8396 22.5924 87.1743 21.9281 87.1265 21.0826ZM79.2852 33.5842H74.4682C74.1335 33.5721 72.8785 33.4513 73.0817 32.026L76.046 17.9903C76.2134 17.181 77.0022 16.5287 77.8031 16.5287H85.955C87.1384 16.5287 88.1664 16.6012 89.0509 16.7341C89.9473 16.867 90.7243 17.1085 91.3817 17.4467C92.0391 17.785 92.4694 18.099 92.9117 18.7633C93.3659 19.4398 93.4734 19.9471 93.5332 20.7684C93.6766 22.7252 92.8399 24.0538 91.1187 25.165C89.529 26.0106 87.3296 26.1434 86.8037 26.1555C86.8037 26.1555 86.2658 26.2763 86.8874 26.4333C86.8874 26.4333 87.6524 26.6266 88.2859 27.1943C89.6366 28.2814 90.6287 29.4047 93.6885 33.572H86.4571C86.4571 33.572 85.214 31.0476 82.6322 27.2912C82.0585 26.4578 81.1261 26.5907 80.7795 26.5544L79.2852 33.5842ZM179.401 30.2987H185.246L184.851 32.1951C184.696 32.9682 183.895 33.5963 183.118 33.5963H173.926C173.592 33.5842 172.337 33.4634 172.54 32.0381L175.504 18.0024C175.672 17.1931 176.46 16.5409 177.261 16.5409H182.341L179.401 30.2987ZM103.705 23.5226H111.379L110.996 25.3103C110.841 26.0954 110.04 26.7718 109.239 26.7718H103.024L102.271 30.2987H109.944L109.55 32.1951C109.394 32.9682 108.594 33.5963 107.817 33.5963H96.7843C96.4496 33.5842 95.1945 33.4634 95.3977 32.0381L98.3621 18.0024C98.5294 17.1931 99.3183 16.5409 100.119 16.5409H112.861L112.479 18.3648C112.311 19.1741 111.522 19.8263 110.721 19.8263H104.494L103.705 23.5226ZM150.728 16.541L150.346 18.3649C150.118 19.2104 149.497 19.8023 148.588 19.8264H148.182C144.536 19.8385 144.309 20.8411 143.604 24.2593L142.732 28.3178C141.668 33.4874 137.054 33.5843 136.66 33.5843H127.42L127.814 31.7604C128.053 30.8666 128.711 30.3593 129.571 30.2989H131.795C135.44 30.2868 135.667 29.2843 136.373 25.866L137.245 21.8076C138.345 16.65 143.903 16.541 144.752 16.541L150.728 16.541Z",
    fill: "#1A213E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20163_45278",
    x1: 9.04935,
    y1: 24.3538,
    x2: 9.50202,
    y2: 26.8948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D85B13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269,
    stopColor: "#E57B0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5447,
    stopColor: "#EF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7964,
    stopColor: "#F5A304"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20163_45278",
    x1: 16.1976,
    y1: 6.88448,
    x2: 42.3888,
    y2: 32.8016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0154,
    stopColor: "#FCC94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1364,
    stopColor: "#F7B01C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1963,
    stopColor: "#F5A709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4906,
    stopColor: "#F5A509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6479,
    stopColor: "#F39D09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7728,
    stopColor: "#F28F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8806,
    stopColor: "#EF7C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9766,
    stopColor: "#EB630B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5C0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20163_45278",
    x1: 14.794,
    y1: 20.2628,
    x2: 57.7457,
    y2: 35.7328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0516,
    stopColor: "#C5C4C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1074,
    stopColor: "#DFDEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1648,
    stopColor: "#F1F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2241,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#FDFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6495,
    stopColor: "#F5F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7602,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#D3D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9461,
    stopColor: "#BAB9B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A5A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20163_45278",
    x1: 20.4749,
    y1: 6.7951,
    x2: 50.2848,
    y2: 17.5316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859,
    stopColor: "#FDCC54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1950A",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20163_45278",
    x1: 31.1287,
    y1: 43.408,
    x2: 31.1287,
    y2: 31.7556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88181E",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4969,
    stopColor: "#B21829",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6534,
    stopColor: "#AA1827",
    stopOpacity: 0.3111
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8996,
    stopColor: "#931821",
    stopOpacity: 0.8004
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88181E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20163_45278",
    x1: 24.3873,
    y1: 44.5627,
    x2: 39.4087,
    y2: 24.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0123,
    stopColor: "#E20334",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0489,
    stopColor: "#DA0531",
    stopOpacity: 0.041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2059,
    stopColor: "#BB0E28",
    stopOpacity: 0.2166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3591,
    stopColor: "#A51421",
    stopOpacity: 0.388
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5056,
    stopColor: "#98181D",
    stopOpacity: 0.5519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#93191C",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95191D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_20163_45278",
    x1: 52.9965,
    y1: 33.7704,
    x2: 52.9965,
    y2: 31.8064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006135,
    stopColor: "#D7D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#D0D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4642,
    stopColor: "#BCBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7894,
    stopColor: "#9C9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#838484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepsolLogo);
export default __webpack_public_path__ + "static/media/repsol_logo.6d00d91bc30bb7715d1a26e680e56ca0.svg";
export { ForwardRef as ReactComponent };